<template>
  <div>
    <!-- create dialog -->
    <custom-dialog
      :openDialog="isOpen"
      :widthDialog="'900px'"
      :classDialog="'create-dialog job-create'"
      :offsetTop="'0px !important'"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('dialogClosed')"
      :appendToBody="true"
      :modalAppendToBody="true"
    >
      <template #body>
        <h3 class="dialogTitle margin-left-0">Tạo mới công việc</h3>
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-position="left"
          label-width="120px"
        >
          <el-row :gutter="24" class="">
            <el-col :span="24" class="margin-bottom-10">
              <el-form-item prop="taskTitle" label="Tên công việc">
                <el-input
                  v-model="form.taskTitle"
                  size="large"
                  v-focus
                  class="noPaddingLeft style-fullWidth input-font__bold input-border__bottom input-border__radius__0 input-count__bottom"
                  placeholder="Nhập tên công việc"
                  prop="name"
                  maxlength="500"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24" class="">
            <el-col :span="8">
              <el-form-item prop="priority" label="Độ ưu tiên">
                <el-select
                  class="input-border__bottom input-border__radius__0 style-fullWidth"
                  v-model="form.priority"
                  placeholder="Độ ưu tiên"
                  size="medium"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in priorities"
                    :key="item.id"
                    :label="item.categoryName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item prop="startDate" label="Ngày bắt đầu">
                <el-date-picker
                  size="medium"
                  class="input-border__bottom input-border__radius__0 style-fullWidth"
                  v-model="form.startDate"
                  @change="updateManday('startDate')"
                  :picker-options="startDatePickerOptions"
                  placeholder="dd/mm/yyyy"
                  type="date"
                  format="dd/MM/yyyy"
                  clearable
                  :prefix-icon="' '"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item prop="deadline" label="Hạn h/thành">
                <el-date-picker
                  size="medium"
                  class="input-border__bottom input-border__radius__0 style-fullWidth"
                  v-model="form.deadline"
                  @change="updateManday('deadline')"
                  :picker-options="endDatePickerOptions"
                  placeholder="dd/mm/yyyy"
                  type="date"
                  format="dd/MM/yyyy"
                  clearable
                  :prefix-icon="' '"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24" class="">
            <el-col :span="16">
              <el-form-item
                prop="delegator"
                label="Người ủy quyền"
                v-if="listDelegator && listDelegator.length"
              >
                <el-select
                  class="input-border__bottom input-border__radius__0 style-fullWidth"
                  v-model="form.delegator"
                  placeholder="Người ủy quyền"
                  size="medium"
                  filterable
                  clearable
                  @change="changeDelegator"
                >
                  <el-option
                    v-for="item in listDelegator"
                    :key="item.id"
                    :label="customLabelSelectPeople(item)"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="16" v-if="taskType !== TASK_TYPE_DANGKI">
              <el-form-item prop="receiverUserDeptRole" label="Người thực hiện">
                <el-select
                  class="input-border__bottom input-border__radius__0 style-fullWidth"
                  v-model="form.receiverUserDeptRole"
                  placeholder="Người thực hiện"
                  size="medium"
                  filterable
                  clearable
                  @change="changeDelegator"
                >
                  <el-option
                    v-for="item in receivers"
                    :key="item.id"
                    :label="customLabelSelectPeople(item)"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="16" v-if="taskType !== TASK_TYPE_GIAOVIEC">
              <el-form-item label="Người giao" prop="assignerUserDeptRole">
                <el-select
                  class="input-border__bottom input-border__radius__0 style-fullWidth"
                  v-model="form.assignerUserDeptRole"
                  placeholder="Người giao "
                  size="medium"
                  filterable
                  clearable
                  @change="changeDelegator"
                >
                  <el-option
                    v-for="item in assigners"
                    :key="item.id"
                    :label="customLabelSelectPeople(item)"
                    :value="item.id"
                  ></el-option>
                </el-select>

                <!--                <multiselect-->
                <!--                  :class="[-->
                <!--                    form.assignerUserDeptRole ? '' : '',-->
                <!--                    'style-fullWidth'-->
                <!--                  ]"-->
                <!--                  :options="assigners"-->
                <!--                  label="fullName"-->
                <!--                  track-by="id"-->
                <!--                  :preselect-first="true"-->
                <!--                  v-model="form.assignerUserDeptRole"-->
                <!--                  :custom-label="customLabelSelectPeople"-->
                <!--                  placeholder="Gõ tên để bắt đầu tìm kiếm"-->
                <!--                  :multiple="false"-->
                <!--                  :close-on-select="true"-->
                <!--                  :clear-on-select="true"-->
                <!--                  :searchable="true"-->
                <!--                  :internal-search="true"-->
                <!--                  open-direction="bottom"-->
                <!--                  @input="assignerUserDeptRoleChange"-->
                <!--                >-->
                <!--                  <template slot="noResult"-->
                <!--                  >Không tìm thấy dữ liệu phù hợp.-->
                <!--                  </template>-->
                <!--                  <template slot="noOptions"-->
                <!--                  >Danh sách trống-->
                <!--                  </template>-->
                <!--                  <template slot="singleLabel" slot-scope="{ option }">-->
                <!--                    <div class="selected-people flex-row flex__left">-->
                <!--                      <div class="img">-->
                <!--                        <div-->
                <!--                          class="avatar_fake flex-row flex__center margin-right-10"-->
                <!--                        >-->
                <!--                          {{ option.fullName | buildShortNameFilter }}-->
                <!--                        </div>-->
                <!--                      </div>-->
                <!--                      <p class="text padding-right-10">{{ option.fullName }}</p>-->
                <!--                    </div>-->
                <!--                  </template>-->
                <!--                </multiselect>-->
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item prop="manday" label="Ngày công">
                <el-input-number
                  size="medium"
                  v-model="form.manday"
                  :min="0.5"
                  class="style-fullWidth input-border__bottom input-border__radius__0"
                  :precision="1"
                  :step="0.5"
                  :controls="false"
                ></el-input-number>
              </el-form-item>
            </el-col>

            <el-col :span="24" class="margin-top-5">
              <el-form-item label="Người phối hợp">
                <task-coodinators
                  :delegatorId="form.delegator || form.assignerUserDeptRole"
                  ref="taskCoodinators"
                  :isAbleToUpdate="true"
                ></task-coodinators>
                <!-- <task-coodinators
                  :selectedItems="form.receiver"
                  ref="receiver"
                  :isAbleToUpdate="true"
                  :type="'receiver'"
                  :receiver="receiver"
                  :currentConfig="currentConfig"
                  @clearValidateFiled="clearValidateFiled"
                  ></task-coodinators> -->
              </el-form-item>
            </el-col>

            <el-col :span="24" class="margin-top-5 margin-bottom-10">
              <el-form-item
                label="Mô tả "
                class="description-job"
                prop="taskDetail"
              >
                <el-input
                  v-model="form.taskDetail"
                  placeholder="Mô tả"
                  type="textarea"
                  class="input-border__bottom input-border__radius__0 style-fullWidth input-count__bottom"
                  size="medium"
                  maxlength="2000"
                  show-word-limit
                  :autosize="{ minRows: 3, maxRows: 10 }"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <task-attachments
                ref="taskAttachments"
                :isAbleToUpdate="true"
                :fieldTitle="'File đính kèm'"
              ></task-attachments>
            </el-col>

            <el-col :span="24">
              <el-form>
                <el-form-item
                  class="style-fullWidth padding-bottom-10"
                  label="Văn bản liên quan"
                >
                  <template>
                    <el-table
                      class="table"
                      style="width: 100%; margin-bottom: 12px"
                      size="medium"
                      max-width="300"
                      :data="docRelations"
                      v-if="docRelations && docRelations.length"
                    >
                      <el-table-column
                        label="Trích yếu"
                        property="quote"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <div class="clickable">
                            <a
                              class="flex-row flex__left margin-left-10"
                              @click="downloadDoc(scope.row)"
                            >
                              <span>
                                <file-type-image
                                  :custom-class="'icon-small margin-right-10 clickable'"
                                >
                                </file-type-image>
                              </span>
                              {{ scope.row.quote || "-" }}
                            </a>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Số ký hiệu"
                        align="left"
                        header-align="left"
                        width="150"
                        property="docCode"
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        label="Ngày văn bản"
                        align="left"
                        header-align="left"
                        width="150"
                        property="docDate"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope"
                          >{{
                            scope.row.docDate
                              | dateFormatter({ dateFormat: "DD/MM/YYYY" })
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        header-align="left"
                        align="left"
                        width="60"
                      >
                        <template slot-scope="scope">
                          <i
                            class="el-icon-circle-close margin-left-10 margin-right-10 font-size__large color__red clickable"
                            @click="removeDocRelation(scope.row)"
                          ></i>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                  <el-button
                    size="medium"
                    type="primary"
                    class="addDocs color__white flex-row flex__center margin-bottom-10 btn-none__border"
                    @click="isOpenAddDocDialog = true"
                  >
                    Thêm văn bản
                    <i class="el-icon-circle-plus font-size__small"></i>
                  </el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-form>
      </template>

      <template #footer>
        <div class="flex-row flex__left form-button__action margin-top-10">
          <el-button
            type="success"
            size="medium"
            class="addDocs btn-none__border color__white bg__blue"
            @click="save"
            :disabled="isProcessing"
          >
            <span class="flex-row flex__center">
              <i
                :class="[
                  !isProcessing
                    ? 'fas fa-save font-size__small'
                    : 'el-icon-loading',
                ]"
              ></i>
              &nbsp;&nbsp;
              {{ viewType === "assigner" ? "Giao việc" : "Đăng ký" }}
            </span>
          </el-button>
          <el-button
            type="info"
            size="medium"
            class="btn__cancel btn-none__border"
            @click="cancel"
          >
            <span class="flex-row flex__center">
              <i class="far fa-times-circle font-size__small"></i>
              &nbsp;&nbsp;Hủy
            </span>
          </el-button>
        </div>
      </template>
    </custom-dialog>

    <dialog-add-docs
      :isOpen="isOpenAddDocDialog"
      :docIds="docIds"
      v-if="isEnableAddDocDialog"
      @closed="isEnableAddDocDialog = false"
      @closeDialog="closeAddDocDialog"
      @submit="addDocRelations"
    />
  </div>
</template>

<script>
import errorMessageFilter from "../../../filters/errorMessageFilter";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import constants from "../../../constants";
import buildShortNameFilter from "../../../filters/buildShortNameFilter";
import buildAttachmentURL from "../../../filters/buildAttachmentURL";
import h from "../../../services/h";
import dateFormatter from "../../../filters/dateFormatter";
import tkTaskService from "../../../services/tkTaskService";
import vbIncomingDocUserViewService from "../../../services/vbIncomingDocUserViewService";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import vbOutgoingDocUserViewService from "../../../services/vbOutgoingDocUserViewService";
import downloadService from "../../../services/downloadService";
import dateUtils from "../../../dateUtils";
import attachmentService from "../../../services/attachmentService";
import tkTaskDocRelationService from "../../../services/tkTaskDocRelationService";
import DialogAddPeople from "./dialog-add-people";
import taskUtils from "../../../services/task/taskUtils";
import utils from "../../../services/utils";
// import TaskCoodinators from "../task-coodinators";
import TaskCoodinators from "../../office/doc/components/task-coodinators.vue";
import TaskAttachments from "../task-attachments";
import CustomDialog from "../../common/custom-dialog";
import DialogAddDocs from "./dialog-add-docs";
import FileTypeImage from "../FileTypeImage";
// import vbDelegateInfoService from "../../../services/vbDelegateInfoService";

export default {
  name: "task-create-dialog",
  mixins: [handleRequestErrorMixin],
  props: [
    "isOpen",
    "taskType",
    "parentTaskId",
    "viewType",
    "docId",
    "docType",
    "copyFromTaskId",
    "forwardTaskId",
  ],
  filters: { buildShortNameFilter, dateFormatter, buildAttachmentURL },
  components: {
    FileTypeImage,
    DialogAddDocs,
    CustomDialog,
    TaskAttachments,
    TaskCoodinators,
    DialogAddPeople,
  },
  data() {
    return {
      docIds: [],
      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
      TASK_TYPE_DANGKI: constants.TASK_TASK_TYPE.DANGKI,
      TASK_TYPE_GIAOVIEC: constants.TASK_TASK_TYPE.GIAOVIEC,

      priorities: [],
      // deadline: null,
      // startDate: null,
      receivers: [],
      listDelegator: [],
      assigners: [],
      docRelations: [],
      coordinatorIds: [],

      isOpenAddDocDialog: false,
      isEnableAddDocDialog: false,
      isProcessing: false,
      // showListDelegator: false,
      // showDelegateRow: false,

      form: {
        taskTitle: null,
        taskDetail: null,
        deadline: null,
        startDate: null,
        parentId: null,
        manday: null,
        priority: null,
        delegator: null,
        // checkTaskDelegate: null,
        receiverUserDeptRole: null,
        assignerUserDeptRole: null,
      },
      docRelationForms: [],
      rules: {
        priority: null,
        taskTitle: null,
        startDate: null,
        taskDetail: null,
        deadline: null,
        manday: null,
        delegator: null,
        receiverUserDeptRole: null,
        assignerUserDeptRole: null,
      },
    };
  },

  watch: {
    isOpenAddDocDialog(newValue) {
      newValue && (this.isEnableAddDocDialog = newValue);
    },
  },

  computed: {
    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    },
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    userDeptRoleId() {
      return this.$store.getters.userDeptRoleId;
    },
    startDatePickerOptions() {
      // Training Camp End Time
      return {
        disabledDate: (time) => {
          if (this.form && this.form.deadline) {
            // The time before today cannot be used as the starting time.
            let endTime = new Date(this.form.deadline);
            endTime.setDate(endTime.getDate());
            return time.getTime() > endTime.getTime();
          } else {
            return false;
          }
        },
      };
    },
    endDatePickerOptions() {
      // Training Camp End Time
      return {
        disabledDate: (time) => {
          if (this.form && this.form.startDate) {
            // The time before today cannot be used as the starting time.
            let startTime = new Date(this.form.startDate);
            startTime.setDate(startTime.getDate());
            return time.getTime() < startTime.getTime();
          } else {
            return false;
          }
        },
      };
    },
  },

  async created() {
    this.initValidationRules();
    await this.loadCategories();
    if (this.copyFromTaskId) await this.initCopyFromTask();
    if (this.forwardTaskId) await this.initForwardTaskId();
    this.taskType !== this.TASK_TYPE_GIAOVIEC && (await this.loadAssigners());
    this.taskType !== this.TASK_TYPE_DANGKI &&
      (await this.loadAllDelegatorByCurrentUser());
    this.taskType !== this.TASK_TYPE_DANGKI && this.loadReceivers();
    this.initAssingerReceiver();
    this.initGiaoViecNhanh();
  },

  methods: {
    updateManday(key) {
      let startTime = this.form.startDate
        ? this.form.startDate.getTime()
        : null;
      let endTime = this.form.deadline ? this.form.deadline.getTime() : null;
      if (startTime && endTime && endTime >= startTime) {
        this.form.manday = (endTime - startTime) / 86400000 + 1;
      }
      if (endTime && startTime && endTime < startTime) {
        if (key === "deadline") {
          let deadlineConstrains = {
            required: true,
            message: "Ngày kết thúc phải không được nhỏ hơn ngày bắt đầu",
            trigger: "blur",
          };
          this.form.deadline = null;
          this.rules.deadline = [deadlineConstrains];
        }
        if (key === "startDate") {
          let startDateConstrains = {
            required: true,
            message: "Ngày bắt đầu phải không được lớn hơn ngày kết thúc",
            trigger: "blur",
          };
          this.form.startDate = null;
          this.rules.startDate = [startDateConstrains];
        }
      }
    },
    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur",
      };
      this.rules.taskTitle = [defaultRequiredConstrains];
      this.rules.taskDetail = [defaultRequiredConstrains];
      this.rules.startDate = [defaultRequiredConstrains];
      this.rules.deadline = [defaultRequiredConstrains];
      this.rules.manday = [defaultRequiredConstrains];
      this.rules.receiverUserDeptRole = [defaultRequiredConstrains];
      this.rules.assignerUserDeptRole = [defaultRequiredConstrains];
      // this.rules.delegator = [defaultRequiredConstrains];
      this.rules.priority = [defaultRequiredConstrains];
    },

    initCopyFromTask() {
      return tkTaskService
        .findById(this.copyFromTaskId)
        .then((response) => response.data)
        .then((copyTkTask) =>
          Promise.all([
            this.initForCopyTask_(copyTkTask),
            this.cloneCoordinator(copyTkTask),
          ])
        );
    },

    initForwardTaskId() {
      return tkTaskService
        .findById(this.forwardTaskId)
        .then((response) => response.data)
        .then((copyTkTask) => this.initForCopyTask_(copyTkTask));
    },

    // checkDelegator() {
    //   if (this.form.checkTaskDelegate) {
    //     this.showListDelegator = true;
    //   } else {
    //     this.showListDelegator = false;
    //   }
    // },

    changeDelegator(event) {
      this.loadReceivers();
    },

    async initForCopyTask_(copyTkTask) {
      this.form.taskTitle = `(Copy) ${copyTkTask.taskTitle}`;
      this.form.taskDetail = copyTkTask.taskDetail;
      this.form.manday = copyTkTask.manday;
      this.form.deadline = copyTkTask.deadline
        ? dateUtils.toMoment(copyTkTask.deadline).toDate()
        : null;
      this.form.startDate = copyTkTask.startDate
        ? dateUtils.toMoment(copyTkTask.startDate).toDate()
        : null;
      this.form.manday = copyTkTask.manday;
      this.form.priority = copyTkTask.priority;
      await this.cloneAttachments(copyTkTask);
      await this.cloneDocRelations(copyTkTask);
    },

    cloneCoordinator(copyTkTask) {
      return userDeptRoleViewService
        .findAllTaskCooperators(copyTkTask.id)
        .then((response) =>
          this.$refs.taskCoodinators.setCoordinators(response.data)
        );
    },

    cloneAttachments(copyTkTask) {
      return attachmentService.cloneFromTask(copyTkTask.id).then((response) => {
        this.$refs.taskAttachments.setVbAttachments(response.data || []);
      });
    },

    cloneDocRelations(copyTkTask) {
      return tkTaskDocRelationService.findAll({ taskId: copyTkTask.id }).then(
        (response) =>
          (this.docRelations = h.collect(response.data, (docRelation_) => {
            this.docIds.push(docRelation_.docId);
            return {
              docId: docRelation_.docId,
              docType: docRelation_.docType,
              quote: docRelation_.quote,
              docCode: docRelation_.docCode,
              docDate: docRelation_.docDate,
            };
          }))
      );
    },

    downloadDoc(taskDocRelation) {
      switch (taskDocRelation.docType) {
        case constants.TASK_DOC_RELATION.VB_DI:
          return downloadService.downloadReferenceOutgoingDoc(
            taskDocRelation.docId
          );
        case constants.TASK_DOC_RELATION.VB_DEN:
          return downloadService.downloadFileIncomingDoc(taskDocRelation.docId);
        default:
          break;
      }
    },

    // trong TH giao viec nhanh tu man hinh chi tiet van ban
    initGiaoViecNhanh() {
      if (!this.docId) return;
      if (this.docType === constants.DOC_TYPE.VB_DEN) {
        vbIncomingDocUserViewService
          .findByDocId(this.docId)
          .then((response) => {
            let docs = response.data;
            let doc = docs && docs.length ? docs[0] : null;
            if (doc) {
              this.docRelations.push({
                docId: doc.vbIncomingDocUserViewKey.id,
                docType: constants.TASK_DOC_RELATION.VB_DEN,
                quote: doc.quote,
                docCode: doc.docCode,
                docDate: doc.docDate,
              });
            }
          });
      } else {
        vbOutgoingDocUserViewService
          .findByDocId(this.docId)
          .then((response) => {
            let docs = response.data;
            let doc = docs && docs.length ? docs[0] : null;
            if (doc) {
              this.docRelations.push({
                docId: doc.docId,
                docType: constants.TASK_DOC_RELATION.VB_DI,
                quote: doc.quote,
                docCode: doc.docCode,
                docDate: doc.docDate,
              });
            }
          });
      }
    },

    // assignerUserDeptRoleChange() {
    //   this.$refs.form.validateField("assignerUserDeptRole");
    // },

    // /**
    //  * trong TH tạo task con thì người thực hiện chỉ có thể là nằm trong danh sách người phối hợp;
    //  **/
    // initReceiversForCreateChildTask() {
    //   tkTaskAssignService
    //     .findAll({taskId: this.parentTaskId})
    //     .then(response => {
    //       let receiverUserDeptRoleIds = h.collect(
    //         response.data,
    //         item => item.receiverUserDeptRoleId
    //       );
    //       userDeptRoleViewService
    //         .findAllByIdIn(receiverUserDeptRoleIds)
    //         .then(response => (this.receivers = response.data));
    //     });
    // },

    removeDocRelation(docRelation) {
      this.docRelations.splice(this.docRelations.indexOf(docRelation), 1);
      this.docIds.splice(this.docIds.indexOf(docRelation.docId), 1);
    },

    initAssingerReceiver() {
      switch (this.taskType) {
        case constants.TASK_TASK_TYPE.DANGKI:
          this.form.receiverUserDeptRole = this.userDeptRoleId;
          break;
        case constants.TASK_TASK_TYPE.GIAOVIEC:
          this.form.assignerUserDeptRole = this.userDeptRoleId;
          break;
      }
    },

    cancel() {
      this.$emit("closeDialog");
    },

    validateForm() {
      return utils.validateFormCommon(this.$refs.form, this.$message);
    },

    convertToSubmitForm() {
      let coordinatorForms = this.$refs.taskCoodinators.getData();
      let attachmentIds = this.$refs.taskAttachments.getData();
      return {
        taskTitle: this.form.taskTitle,
        taskDetail: this.form.taskDetail,
        deadline: this.form.deadline ? this.form.deadline.getTime() : null,
        startDate: this.form.startDate ? this.form.startDate.getTime() : null,
        manday: this.form.manday,
        parentId: this.parentTaskId,
        priorityId: this.form.priority,
        receiverUserDeptRoleId: this.form.receiverUserDeptRole,
        assignerUserDeptRoleId: this.form.assignerUserDeptRole,
        delegatorId: this.form.delegator,
        coordinatorForms: coordinatorForms,
        docRelationForms: h.collect(this.docRelations, (docRelation) => {
          return {
            docId: docRelation.docId,
            docType: docRelation.docType,
            quote: docRelation.quote,
            docCode: docRelation.docCode,
            docDate: docRelation.docDate,
          };
        }),
        attachmentIds: attachmentIds,
      };
    },

    validateDateRange() {
      return new Promise((resolve) => {
        if (this.form.deadline < this.form.startDate) {
          this.$message.error(
            errorMessageFilter({ errorCode: "tkTask.update.invalidDateRange" })
          );
          return;
        }
        resolve();
      });
    },

    save() {
      return this.validateForm()
        .then(() => this.validateDateRange())
        .then(() => {
          let submitForm = this.convertToSubmitForm();
          this.isProcessing = true;
          delete submitForm.parentId;
          submitForm.coordinatorForms = submitForm.coordinatorForms.map(item => ({coordinatorUserDeptRoleId: item.id}));
          return tkTaskService
            .insert(submitForm)
            .then((response) => {
              this.isProcessing = false;
              this.$message({
                message: "Tạo công việc mới thành công",
                type: "success",
              });
              this.$emit("success", { tkTask: response.data });
            })
            .catch((error) => {
              this.isProcessing = false;
              return this.commonHandleRequestError(error);
            });
        });
    },

    loadAssigners() {
      return userDeptRoleViewService
        .findAllAssignersForTask({
          sort: ["positionOrder", "fullName"],
        })
        .then((response) => (this.assigners = response.data));
    },

    loadReceivers() {
      // Open all user for receiver
      // let delegatorId = this.form.delegator;
      userDeptRoleViewService
        // .findAllReceiversForTask(
        //   this.parentTaskId,
        //   null,
        //   {
        //     sort: ["deptName", "positionOrder", "fullName"],
        //   },
        //   delegatorId
        // )
        .findAll()
        .then((response) => (this.receivers = response.data.filter(
            (item) =>
              item.status === "active" &&
              item.usersStatus === "active" &&
              item.deptStatus === "active" && 
              item.positionOrder > this.userDeptRole.positionOrder
          )));
    },

    loadAllDelegatorByCurrentUser() {
      return userDeptRoleViewService
        .findAllDelegatorByToUser()
        .then((response) => {
          this.listDelegator = response.data;
          if (this.listDelegator && this.listDelegator.length > 0) {
            // this.showDelegateRow = true;
          } else {
            // this.showListDelegator = false;
            // this.showDelegateRow = false;
          }
        });
    },

    loadCategories() {
      return taskUtils
        .loadTaskPriorities({
          status: constants.CATEGORY.STATUS.ACTIVE,
        })
        .then((priorities) => (this.priorities = priorities));
    },

    addDocRelations(event) {
      let docType = event.docType;
      h.each(event.docs, (doc) => {
        /**
         * neu van ban da dc add roi thi khong can add nua;
         */

        if (docType === constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DEN) {
          if (
            h.find(
              this.docRelations,
              (docRelation) =>
                docRelation.docId === doc.vbIncomingDocUserViewKey.id
            )
          )
            return;
          this.docIds.push(doc.vbIncomingDocUserViewKey.id);
          this.docRelations.push({
            docId: doc.vbIncomingDocUserViewKey.id,
            docType: constants.TASK_DOC_RELATION.VB_DEN,
            quote: doc.quote,
            docCode: doc.docCode,
            docDate: doc.docDate,
          });
        } else {
          /**
           * neu van ban da dc add roi thi khong can add nua;
           */
          if (
            h.find(
              this.docRelations,
              (docRelation) =>
                docRelation.docId === doc.vbOutgoingDocUserViewKey.id
            )
          )
            return;
          this.docIds.push(doc.vbOutgoingDocUserViewKey.id);
          this.docRelations.push({
            docId: doc.vbOutgoingDocUserViewKey.id,
            docType: constants.TASK_DOC_RELATION.VB_DI,
            quote: doc.quote,
            docCode: doc.docCode,
            docDate: doc.docDate,
          });
        }
      });
      this.isOpenAddDocDialog = false;
    },

    closeAddDocDialog() {
      this.isOpenAddDocDialog = false;
    },

    // customLabelPriority(option) {
    //   return option.categoryName;
    // },

    customLabelSelectPeople(option) {
      return `${option.fullName} (${option.positionName} - ${option.deptName})`;
    },

    // getPriorityClass(name) {
    //   switch (name) {
    //     case "Cao":
    //       return "lv1";
    //     case "Trung bình":
    //       return "lv2";
    //     case "Thấp":
    //       return "lv3";
    //     default:
    //       return "lv3";
    //   }
    // }
  },
};
</script>

<style scoped>
.avatar_fake {
  color: #39ca74;
  background-color: rgba(57, 202, 116, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/views/job/create-job/task-create-dialog.vue